import { useState } from "react";
import { Button, Icon, Select, Option } from "@simplybusiness/mobius";
import { pen } from "@simplybusiness/icons";
import { useSnowplowContext } from "@simplybusiness/services";
import type { CoverLimitEditorProps } from "./types";
import "./CoverLimitEditor.css";

export const CoverLimitEditor = ({
  selectedValue,
  options,
  onChange,
}: CoverLimitEditorProps) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const { snowplow } = useSnowplowContext();

  // Find the selected option to display its label
  const selectedOption = options.find(opt => opt.value === selectedValue);
  const displayLabel = selectedOption?.label || selectedValue;

  const handleLimitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = e.target.value;
    snowplow?.trigger("limitChanged", {
      label: displayLabel,
      limit: newLimit,
    });
    onChange(newLimit);
    setIsEditMode(false);
  };

  const handleEditClick = () => {
    snowplow?.trigger("limitLinkClicked", {
      label: displayLabel,
    });
    setIsEditMode(true);
  };

  if (isEditMode) {
    return (
      <Select
        label="Please select the cover limit you need"
        value={selectedValue}
        onChange={handleLimitChange}
      >
        {options
          .filter(o => o.value !== "0")
          .map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
      </Select>
    );
  }

  return (
    <Button
      variant="link"
      size="sm"
      onClick={handleEditClick}
      aria-label="Edit cover limit"
      className="mobius-cover-limit-editor__button"
    >
      <span>{displayLabel} limit</span>
      <Icon icon={pen} size="xs" />
    </Button>
  );
};
